export default __webpack_public_path__ + "static/media/annex1.9b9392e2.png";